import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59efa608"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "information" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode("先生")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("女士")
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("保存")

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";

import tool from "@/utils/tool";
import router from "@/router/index";
import { Plus } from "@element-plus/icons-vue";
import type {
  UploadFile,
  ElFile,
} from "element-plus/es/components/upload/src/upload.type";

type FormInstance = InstanceType<typeof ElForm>;

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isEdit = ref(false);

const beforeUploadCheckEvent = (file: ElFile) => {
  let types = ["image/jpeg", "image/gif", "image/bmp", "image/png"];
  const isImage = types.includes(file.type);
  const isLt2M = file.size / 1024 / 1024 < 2;

  if (!isImage) {
    ElMessage.error("上传的图片必须是JPG,GIF,BMP,PNG格式!");
  }
  if (!isLt2M) {
    ElMessage.error("上传的图片文件大小不能超过2MB!");
  }
  return isImage && isLt2M;
};

const handleEdit = () => {
  isEdit.value = false;
};
const handleSub = () => {
  isEdit.value = true;
};

const informationFormRef = ref<FormInstance>();

const ustore = useStore();
const bindData = reactive({
  informationForm: {
    code: "",
    avatar: "",
    avatarUrl: "",
    name: "",
    nickName: "",
    sex: "",
    mobile: "",
    cardNo: "",
    province: "",
    city: "",
    area: "",
    address: "",
    department: "",
    job: "",
    cardFrontFile: "",
    cardFrontFileUrl: "",
    cardReverseFile: "",
    cardReverseFileUrl: "",
    areaId: "",
  },
});

const handleAvatarSuccess = (
  response: any,
  file: UploadFile,
  fileList: UploadFile[]
) => {
  bindData.informationForm.avatar = response.result;
  bindData.informationForm.avatarUrl = URL.createObjectURL(file.raw);
};

const handleCardFrontFileSuccess = (
  response: any,
  file: UploadFile,
  fileList: UploadFile[]
) => {
  bindData.informationForm.cardFrontFile = response.result;
  bindData.informationForm.cardFrontFileUrl = URL.createObjectURL(file.raw);
};

const handleCardReverseFileSuccess = (
  response: any,
  file: UploadFile,
  fileList: UploadFile[]
) => {
  bindData.informationForm.cardReverseFile = response.result;
  bindData.informationForm.cardReverseFileUrl = URL.createObjectURL(file.raw);
};

const loadData = () => {
  store.dispatch("getMyInfo").then(
    (data) => {
      //成功
      bindData.informationForm = data.result;
      bindAreaData(bindData.informationForm.area);
    },
    (error) => {
      ElMessageBox.alert(error.msg, "系统消息", {
        confirmButtonText: "关闭",
        callback: (action: Action) => { },
      });
    }
  );
};

loadData();

const defaultValidate = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("请填写登录名"));
  } else {
    callback();
  }
};

const informationRules = reactive({
  code: [{ required: true, validator: defaultValidate, trigger: "blur" }],
  name: [{ required: true, message: "请填写姓名", trigger: "blur" }],
  nickName: [{ required: true, message: "请填写花名", trigger: "blur" }],
  mobile: [{ required: true, message: "请填写手机号", trigger: "blur" }],
  cardNo: [{ required: true, message: "请填写身份证", trigger: "blur" }],
});

var chinaAreaDataOptions = ref("");
tool.getChinaAreaData(function (data) {
  chinaAreaDataOptions.value = data;
});

const selectAreaEvent = (value: any) => {
  if (value.length > 0) {
    var provinceId = value[0];
    var provinceName = tool.areaCodeToText.get(provinceId);
    if (provinceName != undefined) {
      bindData.informationForm.province = provinceName;
    }
    var cityId = value[1];
    var cityName = tool.areaCodeToText.get(cityId);
    if (cityName != undefined) {
      bindData.informationForm.city = cityName;
    }
    bindData.informationForm.areaId = value[2];
    var areaName = tool.areaCodeToText.get(bindData.informationForm.areaId);
    if (areaName != undefined) {
      bindData.informationForm.area = areaName;
    }
  }
};

const bindAreaData = (areaName: string) => {
  if (areaName && areaName.length > 0) {
    var areaValue = tool.areaTextToCode.get(areaName);
    if (areaValue != undefined) {
      bindData.informationForm.areaId = areaValue;
    }
  }
};

const submitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      store
        .dispatch("informationModule/updateMyInfo", bindData.informationForm)
        .then(
          (data) => {
            //成功
            ElMessage.success("保存成功.");
            isEdit.value = true;
            loadData();
          },
          (error) => {
            ElMessageBox.alert(error.msg, "系统消息", {
              confirmButtonText: "关闭",
              callback: (action: Action) => { },
            });
          }
        );
    } else {
      console.log("error submit!");
      return false;
    }
  });
};

const resetForm = (formEl: FormInstance | undefined) => {
  console.log("exec...resetForm");
  if (!formEl) return;
  formEl.resetFields();
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      model: _unref(bindData).informationForm,
      ref_key: "informationFormRef",
      ref: informationFormRef,
      "label-width": "120px",
      inline: false,
      size: "default",
      "status-icon": "",
      rules: _unref(informationRules)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "帐号/登录名",
          prop: "code"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              disabled: true,
              modelValue: _unref(bindData).informationForm.code,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).informationForm.code) = $event)),
              "input-style": "width: 218px"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "个人头像" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: _normalizeClass(["avatar-uploader", _unref(bindData).informationForm.avatar && 'cur-uploader']),
                  action: _unref(tool).url('/personalCenter/uploadAvatar'),
                  "show-file-list": false,
                  "on-success": handleAvatarSuccess,
                  "before-upload": beforeUploadCheckEvent
                }, {
                  default: _withCtx(() => [
                    (_unref(bindData).informationForm.avatar)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _unref(bindData).informationForm.avatarUrl,
                          class: "avatar"
                        }, null, 8, _hoisted_2))
                      : (_openBlock(), _createBlock(_component_el_icon, {
                          key: 1,
                          class: "avatar-uploader-icon"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Plus))
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }, 8, ["class", "action"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "姓名",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              disabled: isEdit.value,
              modelValue: _unref(bindData).informationForm.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).informationForm.name) = $event)),
              "input-style": "width: 218px"
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "花名",
          prop: "nickName"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              disabled: isEdit.value,
              modelValue: _unref(bindData).informationForm.nickName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).informationForm.nickName) = $event)),
              "input-style": "width: 218px"
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "称呼" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: _unref(bindData).informationForm.sex,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).informationForm.sex) = $event)),
              disabled: isEdit.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, { label: 1 }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: 2 }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "手机号",
          prop: "mobile"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              disabled: isEdit.value,
              modelValue: _unref(bindData).informationForm.mobile,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(bindData).informationForm.mobile) = $event)),
              "input-style": "width: 218px"
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "地区" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_cascader, {
              options: _unref(chinaAreaDataOptions),
              onChange: selectAreaEvent,
              modelValue: _unref(bindData).informationForm.areaId,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(bindData).informationForm.areaId) = $event)),
              disabled: isEdit.value
            }, {
              default: _withCtx(({ node, data }) => [
                _createElementVNode("span", null, _toDisplayString(data.label), 1),
                (!node.isLeaf)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, " (" + _toDisplayString(data.children.length) + ") ", 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["options", "modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "住址" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              disabled: isEdit.value,
              modelValue: _unref(bindData).informationForm.address,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(bindData).informationForm.address) = $event)),
              "input-style": "width: 218px"
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "公司名称" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              disabled: isEdit.value,
              modelValue: _unref(bindData).informationForm.department,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(bindData).informationForm.department) = $event)),
              "input-style": "width: 218px"
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "职务" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _unref(bindData).informationForm.job,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(bindData).informationForm.job) = $event)),
              disabled: isEdit.value,
              "input-style": "width: 218px"
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "身份证号码",
          prop: "cardNo"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              disabled: isEdit.value,
              modelValue: _unref(bindData).informationForm.cardNo,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(bindData).informationForm.cardNo) = $event)),
              "input-style": "width: 218px"
            }, null, 8, ["disabled", "modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "证件照-正面" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: _normalizeClass(["avatar-uploader", _unref(bindData).informationForm.cardFrontFile && 'cur-uploader']),
                  action: _unref(tool).url('/personalCenter/uploadImageFile'),
                  "show-file-list": false,
                  "on-success": handleCardFrontFileSuccess,
                  "before-upload": beforeUploadCheckEvent,
                  disabled: isEdit.value
                }, {
                  default: _withCtx(() => [
                    (_unref(bindData).informationForm.cardFrontFile)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _unref(bindData).informationForm.cardFrontFileUrl,
                          class: "avatar"
                        }, null, 8, _hoisted_6))
                      : (_openBlock(), _createBlock(_component_el_icon, {
                          key: 1,
                          class: "avatar-uploader-icon"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Plus))
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }, 8, ["class", "action", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "证件照-反面" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_container, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: _normalizeClass(["avatar-uploader", _unref(bindData).informationForm.cardReverseFile && 'cur-uploader']),
                  action: _unref(tool).url('/personalCenter/uploadImageFile'),
                  "show-file-list": false,
                  "on-success": handleCardReverseFileSuccess,
                  "before-upload": beforeUploadCheckEvent,
                  disabled: isEdit.value
                }, {
                  default: _withCtx(() => [
                    (_unref(bindData).informationForm.cardReverseFile)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _unref(bindData).informationForm.cardReverseFileUrl,
                          class: "avatar"
                        }, null, 8, _hoisted_7))
                      : (_openBlock(), _createBlock(_component_el_icon, {
                          key: 1,
                          class: "avatar-uploader-icon"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Plus))
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }, 8, ["class", "action", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules"]),
    _createVNode(_component_el_container, { class: "information-btn" }, {
      default: _withCtx(() => [
        (isEdit.value)
          ? (_openBlock(), _createBlock(_unref(ElButton), {
              key: 0,
              type: "primary",
              size: "large",
              onClick: handleEdit
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_unref(ElButton), {
              key: 1,
              type: "primary",
              size: "large",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (submitForm(informationFormRef.value)))
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }))
      ]),
      _: 1
    })
  ]))
}
}

})